import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class FareModel {
    constructor() {
        const storedData = JSON.parse(localStorage.getItem("fareData")) || {};
        this._fareData = storedData;

        if (Object.keys(this._fareData).length === 0) {
            this.initializeFromAPI();
        }
    }

    async initializeFromAPI() {
        try {
            const response = await axios.get(`${API_BASE_URL}fare`);
            if (response.data && response.data.data) {
                const fetchedData = response.data.data;

                this.setFareData(fetchedData);
                localStorage.setItem("fareData", JSON.stringify(fetchedData));
                this._fareData = fetchedData;
            } else {
                console.warn("No fare data found in API response.");
            }
        } catch (error) {
            console.error("Error fetching fare data:", error);
        }
    }

    setFareData(data) {
        this._fareData = data;
    }

    get fareData() {
        return this._fareData;
    }

    get CGSTPercent() { return this._fareData.CGSTPercent || 0; }
    get SpecialRateCialTrip() { return this._fareData.SpecialRateCialTrip || 0; }
    get CCCardCharge() { return this._fareData.CCCardCharge || 0; }
    get DCCardCharge() { return this._fareData.DCCardCharge || 0; }
    get DCMinCharge() { return this._fareData.DCMinCharge || 0; }
    get CCMinCharge() { return this._fareData.CCMinCharge || 0; }
    get WaitingChargeCialTripPerMinute() { return this._fareData.WaitingChargeCialTripPerMinute || 0; }
    get SGSTPercent() { return this._fareData.SGSTPercent || 0; }
    get surchargePercent() { return this._fareData.surchargePercent || 0; }
    get surchargePerKM() { return this._fareData.surchargePerKM || 0; }
    get educationalCessPercent() { return this._fareData.educationalCessPercent || 0; }
    get WaitingCharge() { return this._fareData.WaitingCharge || 0; }
    get runningTimePerKM() { return this._fareData.runningTimePerKM || 0; }
    get ordinaryRate() { return this._fareData.ordinaryRate || 0; }
    get minimumKM() { return this._fareData.minimumKM || 0; }
    get floodCessPercent() { return this._fareData.floodCessPercent || 0; }
    get SanitizationCharge() { return this._fareData.SanitizationCharge || 0; }
    get IsACWordRequired() { return this._fareData.IsACWordRequired || 0; }
}

export default new FareModel();